import ObjectType from './ObjectType';
const ArrayType = Object.seal({
    fullName: 'Array',
    name: 'Array',
    namespace: '',
    baseType: ObjectType,
    isArray: true,
    factory: Array,
});
export default ArrayType;
